"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandidateUpdateAccountSettingsBodySchema = void 0;
const schemas_1 = require("../../../schemas");
exports.CandidateUpdateAccountSettingsBodySchema = schemas_1.CandidateSchema.pick({
    openToCompanyOffer: true,
    openToDirectMessage: true,
    subscribedToNewsletter: true,
}).partial();
